<template>
  <section class="wrap_pop">
    <div class="popbox_wrap">
      <div class="popbox_cont type2">
        <h1 class="pop_tit">인증번호 입력</h1>
        <div class="form_wrap">
          <ul>
            <li>
              <div class="form_area">
                <!-- 인풋 포커스 : focus 클래스 추가 -->
                <input
                  type="tel"
                  class="form_input"
                  placeholder="인증번호 6자리"
                  maxlength="6"
                  v-model="smsAthNo"
                  @keyup="validateInput"
                  @blur="validateInput"
                />
                <button type="button" class="btn_round" @click="rqeMobAth">
                  <span>재전송</span>
                </button>
              </div>
              <div class="form_guide error">
                <!-- 에러일 경우 : error 클래스 추가  -->
                <p class="txt_alert"><span>인증번호를 입력하세요.</span></p>
                <div class="txt_time">
                  <span>남은시간:{{ timer.remainAthHr }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <ul class="txt_list">
          <li>3분이내로 인증번호를 입력해 주세요.</li>
          <li>입력시간 초과시 재전송 버튼을 눌러주세요.</li>
        </ul>
      </div>
      <div class="popbox_btn">
        <div>
          <button type="button" class="btn color1" @click="cnfMobAth">
            인증하기
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, reactive, inject, onMounted, computed, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { load, sessionUserInfo } from "@/common/sessionFactory";
import useFormValidation from "@/common/validation";
import util from "@/common/util";
import useDialog from "@/common/dialog";
export default {
  props: {
    param: Object,
  },
  setup(props, context) {
    const router = useRouter();
    const axios = inject("axios");
    const store = useStore();
    const dialog = useDialog(inject("$vfm"));

    const { validateNameField, errors, id } = useFormValidation();

    if (util.isEmpty(props.param)) {
      dialog.alert("비정상적인 접근입니다.").then(() => context.emit("close"));
      return;
    }

    let smsAthNo = ref("");

    const validateInput = () => {
      validateNameField(props.label, smsAthNo.value);
    };

    const timer = reactive({
      timerFlag: false,
      timerID: "",
      athStdHr: 180, // 인증기준시간
      athHr: 180, // 인증시간
      athInhrNo: "", // 인증고유번호
      remainAthHr: computed(() => toMinSec(timer.athHr)),
    });

    onMounted(async () => {
      await load();
      // console.log(props)
      // rqeMobAth()
      start_timer();

      timer.timerFlag = true;
      timer.athInhrNo = props.param.athInhrNo;
      util.saveLog("009", "인증번호입력"); // 009 : 화면진입
    });

    onUnmounted(() => {
      clearInterval(timer.timerID);
    });

    const rqeMobAth = () => {
      let param = {};
      param.fnm = props.param.fnm;
      param.gndr = props.param.gndr;
      param.bdt = props.param.bdt;
      param.ccoDiv = props.param.ccoDiv.code;
      param.cellNo = props.param.cellNo;
      param.cusNo =
        props.param.cusNo || Math.floor(Math.random() * 1000000) + "";

      axios.json("/mobAth/rqeMobAth.do", param).then(function (result) {
        let spclRspnCd = result.data.spclRspnCd; //전문응답코드
        let athRsl = result.data.athRsl; //휴대폰인증결과
        let dialogMsg = "";

        timer.athInhrNo = result.data.athInhrNo; //인증고유번호

        if (spclRspnCd == "P000") {
          if (athRsl == "0000" || athRsl == "000M") {
            start_timer();
            dialogMsg = "인증번호가 발송되었습니다.";

            timer.timerFlag = true;
          } else if (athRsl == "0001") {
            dialogMsg =
              "이동전화번호/생년월일(성별) 불일치입니다. 확인 후 다시 시도해주세요.";
          } else if (athRsl == "0002") {
            dialogMsg = "이통사 고객이 아닙니다. 확인 후 다시 시도해주세요.";
          } else if (athRsl == "0004") {
            dialogMsg =
              "이동전화번호/성명 불일치입니다. 확인 후 다시 시도해주세요.";
          } else if (athRsl == "0006") {
            dialogMsg =
              "인증실패(법인폰) 하였습니다. 확인 후 다시 시도해주세요.";
          } else if (athRsl == "0007") {
            dialogMsg =
              "인증실패(선불폰) 하였습니다. 확인 후 다시 시도해주세요.";
          } else if (athRsl == "0008") {
            dialogMsg = "일시정지 휴대폰입니다. 확인 후 다시 시도해주세요.";
          }
        } else if (spclRspnCd == "P001") {
          dialogMsg =
            "주민번호 유효성(체크섬) 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "P005") {
          dialogMsg =
            "참가기관ID 존재하지 않습니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "P013") {
          dialogMsg = "서비스이용 권한 없습니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S101") {
          dialogMsg = "이동통신사 구분 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S102") {
          dialogMsg =
            "이동통신사 통신 오류(이통사 타임아웃 및 연결오류)입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S602") {
          dialogMsg = "SMS발송구분 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S603") {
          dialogMsg = "내부 DB오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S700") {
          dialogMsg =
            "개인구분코드 입력되지 않았습니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "S733") {
          dialogMsg =
            "명의도용차단 설정에 따른 본인인증 미대상입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "L399") {
          dialogMsg =
            "인증 입력값 오류(주민번호, 성명, 휴대폰번호)입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "E998") {
          dialogMsg = "기타 권한 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "E999") {
          dialogMsg = "내부시스템 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "E###") {
          dialogMsg = "기타시스템 오류입니다. 확인 후 다시 시도해주세요.";
        } else if (spclRspnCd == "0000") {
          dialogMsg =
            "메리츠화재 전산에 등록된 휴대폰번호와 일치하지 않습니다.";
        } else {
          dialogMsg =
            "인증번호 발송 요청이 실패하였습니다. 잠시 후 다시 시도해주세요.";
        }

        dialog.alert(dialogMsg);
      });
    };

    //타이머 시작
    function start_timer() {
      clearInterval(timer.timerID);
      timer.athHr = timer.athStdHr;
      timer.timerID = setInterval(function () {
        decrementTime();
      }, 1000);
    }

    function decrementTime() {
      if (timer.athHr > 0) {
        timer.athHr--;
      } else {
        clearInterval(timer.timerID); //인증시간 만료
        dialog.alert(
          "인증시간이 만료되었습니다.\n\n인증번호 재발송 하신 후 진행하세요."
        );
        timer.timerFlag = false;
      }
    }

    function toMinSec(t) {
      var hour;
      var min;
      var sec;

      hour = Math.floor(t / 3600);
      min = Math.floor(t / 60);
      sec = t - hour * 3600 - min * 60;
      if (sec < 10) sec = "0" + sec;
      return " " + min + "분 " + sec + "초";
    }

    const cnfMobAth = () => {
      let errorMsg = "";

      if (!timer.timerFlag) {
        errorMsg =
          "인증시간이 만료되었습니다.\n\n인증번호 재발송 하신 후 진행하세요.";
      } else if (util.isNull(smsAthNo.value) || util.isEmpty(smsAthNo.value)) {
        errorMsg = "인증번호를 입력해주세요.";
      }

      if (!_.isEmpty(errorMsg)) {
        dialog.alert(errorMsg);
        return;
      } else {
        let param = {};
        param.smsAthNo = smsAthNo.value; //sms인증번호(OTP)
        param.athInhrNo = timer.athInhrNo; //인증고유번호
        param.cusNo = sessionUserInfo.cusNo;
        axios.json("/mobAth/cnfMobAth.do", param).then(function (result) {
          let spclRspnCd = result.data.spclRspnCd; //전문응답코드 (P000: 정상응답코드)
          let athCnfRsl = result.data.athCnfRsl; //휴대폰인증결과 (0000: 인증성공)
          if (spclRspnCd == "P000") {
            if (athCnfRsl == "0000" || athCnfRsl == "000M") {
              dialog.alert("정상적으로 인증되었습니다.").then(function () {
                clearInterval(timer.timerID); //인증시간 만료
                let param1 = {};
                param1.prctrNo = sessionUserInfo.prctrNo;
                param1.athNo = smsAthNo.value;
                param1.ctnsKdCd = sessionUserInfo.ctnsKdCd;
                param1.orgCd = sessionUserInfo.orgCd;
                param1.cusNo =
                  sessionUserInfo.cusNo ||
                  Math.floor(Math.random() * 1000000) + "";
                param1.pcsCtnsSndReqId = sessionUserInfo.dataId;
                param1.elcSgnSelfAthMdCd = "01";

                if (!store.state.elcSgnInf.isRpsMbl) {
                  axios
                    .json("/registPrtblAthNo.do", param1)
                    .then(function (result) {
                      router.push({ name: "ctrBasMttCnf" });
                      context.emit("close");
                    });
                } else {
                  store.commit("elcSgnInf/changeAthData", param1);
                  router.push({ name: "ctrLstCho" });
                  context.emit("close");
                }
              });
            } else if (athCnfRsl == "0001") {
              dialog.alert("인증번호 불일치입니다. 확인 후 다시 시도해주세요.");
              return;
            } else if (athCnfRsl == "0031") {
              dialog.alert(
                "해당 인증 요청 확인 불가입니다. 확인 후 다시 시도해주세요."
              );
              return;
            } else if (athCnfRsl == "0033") {
              dialog.alert(
                "인증고유번호 불일치입니다. 확인 후 다시 시도해주세요."
              );
              return;
            } else if (athCnfRsl == "0034") {
              dialog.alert("기 인증 완료건입니다. 확인 후 다시 시도해주세요.");
              return;
            }
          } else if (spclRspnCd == "P001") {
            dialog.alert(
              "주민번호 유효성(체크섬) 오류입니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "P005") {
            dialog.alert(
              "참가기관ID 존재하지 않습니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "P013") {
            dialog.alert(
              "서비스이용 권한 없습니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "S101") {
            dialog.alert(
              "이동통신사 구분 오류입니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "S102") {
            dialog.alert(
              "이동통신사 통신 오류(이통사 타임아웃 및 연결오류)입니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "S602") {
            dialog.alert("SMS발송구분 오류입니다. 확인 후 다시 시도해주세요.");
            return;
          } else if (spclRspnCd == "S603") {
            dialog.alert("내부 DB오류입니다. 확인 후 다시 시도해주세요.");
            return;
          } else if (spclRspnCd == "S700") {
            dialog.alert(
              "개인구분코드 입력되지 않았습니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "S733") {
            dialog.alert(
              "명의도용차단 설정에 따른 본인인증 미대상입니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "L399") {
            dialog.alert(
              "인증 입력값 오류(주민번호, 성명, 휴대폰번호)입니다. 확인 후 다시 시도해주세요."
            );
            return;
          } else if (spclRspnCd == "E998") {
            dialog.alert("기타 권한 오류입니다. 확인 후 다시 시도해주세요.");
            return;
          } else if (spclRspnCd == "E999") {
            dialog.alert("내부시스템 오류입니다. 확인 후 다시 시도해주세요.");
            return;
          } else if (spclRspnCd == "E###") {
            dialog.alert("기타시스템 오류입니다. 확인 후 다시 시도해주세요.");
            return;
          } else {
            dialog.alert("인증 실패하였습니다. 잠시 후 다시 시도해주세요.");
            return;
          }
        });
      }
    };

    return {
      smsAthNo,
      timer,
      validateInput,
      rqeMobAth,
      cnfMobAth,
    };
  },
};
</script>
